import React from 'react'
import './About.css'
import { Link } from 'react-router-dom'
function About() {
  return (
    <>
      <section className="about-section">
        <h2 className="about-heading">About AHH International</h2>

        <div className="about-img-box">
          <img src="./img/ceo.png" alt="Owner" className="owner-img" />
          <div className="owner-name-tag">Shafaqat Mehmood <br/> Founder & CEO</div>
        </div>

        <p className="about-lead">
        At <strong>AHH International</strong>, we are more than just exporters — we proudly represent Pakistan’s rich agricultural and industrial heritage. With a strong focus on quality and sustainability, we supply a wide range of premium products, including mangoes, bananas, mandarins, mixed vegetables, potatoes, garlic, ginger, dates, dry fruits, pulses, rice, salt, animal feed, meat, towels, and bedsheets.

From our fields and factories to customers around the world, we are committed to delivering excellence in every shipment.
        </p>

        <ul className="about-list">
          <li><strong>Years of Excellence:</strong> Over a decade of experience in agri-exports.</li>
          <li><strong>Global Footprint:</strong> Supplying markets in the Middle East, Europe, and beyond.</li>
          <li><strong>Community Focused:</strong> Supporting thousands of farmers and households.</li>
          <li><strong>Eco-Friendly:</strong> Committed to sustainable farming and ethical sourcing.</li>
        </ul>

        <div className="about-btn-container">
          <Link to='/contact' className="card-btn">Discover More</Link>
        </div>
      </section>

      <section className="partner-section py-5">
  <div className="container1 ">
    <div className='text-center mt-4'>
    <h2 className="text-center section-heading">Meet Our Partners</h2></div>
    <div className="row justify-content-center mt-4">
      
      {/* Partner 1 */}
      <div className="col-12 col-sm-6 col-md-4 col-lg-2 mt-4" style={{marginLeft:'0px'}}>
      <div className="about-img-box">
          <img src="/img/umarfaroor.png" alt="Owner" className="owner-img" />
          <div className="owner-name-tag text-center">Umar Farooq <br/>Director Finance</div>
        </div>
      </div>
      {/* Partner 2 */}
      <div className="col-12 col-sm-6 col-md-4 col-lg-2 mt-4" style={{marginLeft:'0px'}}>
      <div className="about-img-box">
          <img src="./img/umarhayyat.png" alt="Owner" className="owner-img" />
          <div className="owner-name-tag text-center">Umar Hayyat <br/>Director (Procurement & Record)</div>
        </div>
      </div>
      {/* Partner 3 */}
      <div className="col-12 col-sm-6 col-md-4 col-lg-2 mt-4" style={{marginLeft:'0px'}}>
      <div className="about-img-box">
          <img src="/img/msallah.png" alt="Owner" className="owner-img" />
          <div className="owner-name-tag text-center">Muhammad Sallah <br/>from Saudia Arabia (Director)</div>
        </div>
      </div>

      {/* Partner 4 */}
      <div className="col-12 col-sm-6 col-md-4 col-lg-2 mt-4" style={{marginLeft:'0px'}}>
      <div className="about-img-box">
          <img src="/img/sajid.png" alt="Owner" className="owner-img" />
          <div className="owner-name-tag text-center">Sajid Hussain <br/>Director (Management)</div>
        </div>
      </div>
      {/* Partner 5 */}
      <div className="col-12 col-sm-6 col-md-4 col-lg-2 mt-4" style={{marginLeft:'0px'}}>
      <div className="about-img-box">
          <img src="/img/khubib.png" alt="Owner" className="owner-img" />
          <div className="owner-name-tag text-center">Khubaib Farid <br/>Director (I.R)</div>
        </div>
      </div>


    </div>
  </div>
</section>



      <div className="values-section">
        <h2 className="values-heading">O u r &nbsp; v a l u e s</h2>
        <p className="values-subheading">Be the change you want to see in world</p>

        <div className="values-grid">
          <div className="value-card">
            <h4>I T ’ S &nbsp; A L L &nbsp; E C O &nbsp; C E R T I F I E D</h4>
            <p>We have 100% certified ecological farms. This is a principle that’s engrained not just in our work, but in our family too. We trust nature and that it knows best.</p>
          </div>
          <div className="value-card">
            <h4>S u p e r &nbsp; f r e s h</h4>
            <p>There is no time to waste with organic produce. Use it up when it’s at its best, and cut out the need for preservatives or other additives.</p>
          </div>
          <div className="value-card">
            <h4>F A M I L Y &nbsp; O W N E D</h4>
            <p>AHH International’s produce is a family owned and run business. When we retire, all of the fruits of our labor will be left for our kids and grandkids to run.</p>
          </div>
          <div className="value-card">
            <h4>S U S T A I N A B L E &nbsp; F A R M I N G</h4>
            <p>We live by the principle that our work has to be good for the nature. We are working towards running a fully zero-waste organic farm here at AHH International Group.</p>
          </div>
        </div>
      </div>
      <div className='text-center'>
        <Link to='/contact' class="read-more-btn">
          <span>Read More</span>
        </Link></div>



    </>
  )
}

export default About
